import { store } from 'app/redux/store';
import { IUser } from 'app/services/user';
import { updateKey } from '../edit/TaxQuestionnaire/PersonalDetails/TheBasics/Name/slice';

export default function autoFillNameSlice(user: IUser) {
  const { given_name, family_name, ssn, birth_date, occupation, phone_number } =
    user;

  store.dispatch(updateKey({ key: 'firstName', value: given_name }));
  store.dispatch(updateKey({ key: 'lastName', value: family_name }));
  store.dispatch(updateKey({ key: 'socialSecurityNumber', value: ssn }));
  store.dispatch(updateKey({ key: 'dateOfBirth', value: birth_date }));
  store.dispatch(updateKey({ key: 'profession', value: occupation }));
  store.dispatch(updateKey({ key: 'phoneNumber', value: phone_number }));
}
